import React, { useEffect, useState } from "react";
import { Box, Container, Typography, Grid, Paper, Button, CircularProgress } from "@mui/material";
import Navbar from "./common/Navbar";
import Footer from "./common/Footer";
import axios from "axios";

const OfferPage = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const res = await axios.get("http://localhost:3001/api/offers");
        
        if (res.data && res.data.length > 0) {
          setOffers(res.data);
        }
      } catch (err) {
        console.error("Backend error, showing fallbacks", err);
        // Fallback data agar backend connect na ho
        setOffers([
          { _id: "1", title: "WELCOME20", description: "Get 20% off on your first order!", bgColor: "#fdf0f0" },
          { _id: "2", title: "FREE DELIVERY", description: "Free delivery on orders above ₹500", bgColor: "#f0fdf4" }
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchOffers();
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#fff8f0", display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      
      <Container maxWidth="lg" sx={{ py: 8, flexGrow: 1 }}>
        <Typography
          variant="h3"
          fontWeight="bold"
          color="#3E2723"
          sx={{ mb: 6, textAlign: "center", fontFamily: "'Playfair Display', serif" }}
        >
          🎁 Exciting Offers & Promotions 🎁
        </Typography>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
            <CircularProgress sx={{ color: "#6d3610" }} />
          </Box>
        ) : (
          <Grid container spacing={4}>
            {offers.map((offer) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={offer._id}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    height: '100%',
                    borderRadius: 5,
                    textAlign: "center",
                    bgcolor: offer.bgColor || "#ffffff", // Admin se aaya color
                    border: '1px solid rgba(0,0,0,0.05)',
                    transition: "all 0.3s ease",
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    "&:hover": {
                      transform: "translateY(-10px)",
                      boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      sx={{ mb: 2, color: "#6d3610", textTransform: 'uppercase' }}
                    >
                      {offer.title}
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 4, lineHeight: 1.6 }}>
                      {offer.description}
                    </Typography>
                  </Box>
                  
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{
                      bgcolor: "#6d3610",
                      color: "#fff",
                      py: 1.5,
                      borderRadius: 2,
                      fontWeight: 'bold',
                      "&:hover": { bgcolor: "#3E2723" },
                    }}
                  >
                    Grab Now
                  </Button>
                </Paper>
              </Grid>
            ))}
          </Grid>
        )}

        {!loading && offers.length === 0 && (
          <Typography variant="h6" textAlign="center" color="text.secondary">
            No active offers at the moment. Check back soon!
          </Typography>
        )}
      </Container>

      <Footer />
    </Box>
  );
};

export default OfferPage;